import { render, staticRenderFns } from "./DocumentsSecureList.vue?vue&type=template&id=a4fd2776&scoped=true&"
import script from "./DocumentsSecureList.vue?vue&type=script&lang=js&"
export * from "./DocumentsSecureList.vue?vue&type=script&lang=js&"
import style0 from "./DocumentsSecureList.vue?vue&type=style&index=0&id=a4fd2776&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4fd2776",
  null
  
)

export default component.exports